import * as Yup from 'yup';
import { InsuranceFields, NAERING, PRIVAT } from '@/data/Types';
import { personalInfoFields } from '@/forms/fields/personalInfo';
import { formFieldsInitialValues, formFieldsValidationSchema } from '@/forms/fields/utils';

const validation = {
    type: Yup.string().required('Du må oppgi om du trenger privat- eller næringsforsikring'),
    insuranceDescription: Yup.string().when('type', {
        is: NAERING,
        then: (schema) => schema.required('Du må beskrive hva henvendelsen gjelder'),
    }),
    insurances: Yup.array().when('type', {
        is: PRIVAT,
        then: (schema) => schema.min(1, 'Du må oppgi hvilke forsikringer du er interessert i'),
    }),
};

const insuranceFields: InsuranceFields = {
    ...personalInfoFields,
    type: {
        validation: validation.type,
        initialValue: PRIVAT,
        required: true,
    },
    insuranceDescription: {
        validation: validation.insuranceDescription,
        initialValue: '',
        required: true,
    },
    insurances: {
        validation: validation.insurances,
        initialValue: [],
        required: true,
    },
};

export type InsuranceFieldNames = keyof typeof insuranceFields;
export const insuranceInitialValues = () => formFieldsInitialValues(insuranceFields);
export const insuranceValidationSchema = () => formFieldsValidationSchema(insuranceFields);
